import { instance as axios, DHLLabelInstance } from '../http'
import { DOWNLOAD_LABELS, DHL_LABELS, DHL_DOWNLOAD } from '../endpoints'

const postLmLabels = query => axios.get(`${DOWNLOAD_LABELS}?${query}`, { responseType: 'blob' })
const getDHLLabel = blob => DHLLabelInstance.get(`${DHL_LABELS}/${blob.storeCode}/${blob.customerOrderCode}`)
const getDHLFile = blob => DHLLabelInstance.get(`${DHL_LABELS}/${blob.labelId}/${DHL_DOWNLOAD}`, { responseType: 'blob' })

export default {
  postLmLabels,
  getDHLLabel,
  getDHLFile
}



// WEBPACK FOOTER //
// ./src/repository/api/labels.js